import React, { useState } from 'react';
import Button from '../../../button';
import ButtonSelect from '../../../button-select';
import CloseSVG from '../../../../assets/svg/close.svg';
import BulkAddAttendanceSchedule from './add-bulk-schedule';
import AddAttendanceSchedule from './add-attendance-schedule';
import Modal from '../../modal';

function SelectScheduleOption({ isOpen, closeModal, refresh }) {
  const [option, setOption] = useState('single');
  const [showAddAttendance, setShowAddAttendance] = useState(false);
  const [showAddBulkAttendance, setShowAddBulkAttendance] = useState(false);

  function submit() {
    if (option === 'single') {
      setShowAddAttendance(true);
    } else if (option === 'bulk') {
      setShowAddBulkAttendance(true);
    }
  }

  return (
    <>
      {showAddAttendance ? (
        <AddAttendanceSchedule
          isOpen={showAddAttendance}
          closeModal={() => {
            setShowAddAttendance(false);
            closeModal();
          }}
          bonusData={null}
          title='Add Attendance Schedule'
          buttonText='ADD SCHEDULE'
        />
      ) : null}
      {showAddBulkAttendance ? (
        <BulkAddAttendanceSchedule
          isOpen={showAddBulkAttendance}
          closeModal={() => setShowAddBulkAttendance(false)}
          completed={() => {
            setShowAddBulkAttendance(false);
            closeModal();
          }}
        />
      ) : null}

      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Add Attendance Schedule</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col items-center w-full'>
            <span className='text-left text-[14px] -mb-3'>
              Select your desired option to add Attendance Schedule
            </span>
            <div className='flex flex-col justify-center h-full min-h-[400px] px-8 w-full'>
              <ButtonSelect
                title={'Add Single Schedule'}
                subtitle={'Add Single Attendance Schedule'}
                isActive={option === 'single'}
                onClick={() => setOption('single')}
              />

              <ButtonSelect
                title={'Import  Attendance Schedule'}
                subtitle={'Add Attendance Schedule using a XLSX file'}
                isActive={option === 'bulk'}
                onClick={() => setOption('bulk')}
                className='mt-4'
              />

              <div className='w-full mt-[20px]'>
                <Button 
                  text='NEXT' 
                  type='submit' 
                  onClick={() => submit()} 
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SelectScheduleOption;
